module.exports = __webpack_public_path__ + "img/2_2_4.6e7d317a.png";